import axios from 'axios';
import { Message } from 'element-ui';
import store from '@/store';
import router from '@/router';
import {refresh} from "@/api/utils";

const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
    // withCredentials: true, // send cookies when cross-domain requests
    timeout: 5000 // request timeout
});

// request interceptor
service.interceptors.request.use(
    config => {
        // do something before request is sent
        if (store.getters.token) {
            // let each request carry token
            // ['HxToken'] is a custom headers key
            config.headers.common["Authorization"] = "Bearer " + store.getters.token;
        }
        return config;
    },
    error => {
        // do something with request error
        // console.log(error); // for debug
        return Promise.reject(error);
    }
);
service.interceptors.response.use(
    response => {
        if (response.headers['content-type'] && response.headers['content-type'].indexOf('json') > -1)
            return Promise.resolve(response.data);
        else
            return Promise.resolve(response);
    },
    async error => {
        let errorInfo = '';
        const originalRequest = error.config;
        switch (error.response.status) {
            case 401:
                if (error.response.status === 401) {
                    let res  = await refresh({
                        jwtToken: store.getters.token,
                        refreshToken: store.getters.refreshToken
                    });
                    // isRefreshing = false;
                    if (res.Code === 1) {
                        let loginInfo = {
                            token: res.Data.token,
                            refreshToken: res.Data.refreshToken,
                            name: store.getters.name,
                            menu: store.getters.menu,
                            toolbar: store.getters.toolbar,
                            avatar: store.getters.avatar
                        };
                        store.commit('user/SET_LOGININFO', loginInfo);
                        axios.defaults.headers.common['Authorization'] = `Bearer ${loginInfo.token}`;
                        originalRequest.headers.Authorization = `Bearer ${loginInfo.token}`;
                        // console.log("token refreshed!");
                        return service(originalRequest);
                    } else {
                        // 返回错误，需要重新登录
                        store.commit('user/REMOVE_LOGININFO');
                        errorInfo = "未取得认证,请先登录";
                        Message({
                            message: errorInfo,
                            type: 'error',
                            duration: 5 * 1000
                        });
                        router.push({ name: "login" }).catch(() => { });
                        // return Promise.reject(err);
                        return Promise.resolve(error);
                    }
                }
                break;
            case 403:
                errorInfo = "禁止访问该资源";
                break
            case 500:
                errorInfo = "抱歉，服务器开了点小差，请稍后访问";
                break
            default:
                // do something...
                break
        }
        Message({
            message: errorInfo,
            type: 'error',
            duration: 5 * 1000
        });
        return Promise.resolve(error);
    }
);

export default service;
